export default "__VITE_ASSET__fbf0c6a3__"